module.exports = __webpack_public_path__ + "img/FixedTime.d3c42347.svg";